import { render, staticRenderFns } from "./programAddPage.vue?vue&type=template&id=ceb492ee&scoped=true&"
import script from "./programAddPage.vue?vue&type=script&lang=js&"
export * from "./programAddPage.vue?vue&type=script&lang=js&"
import style0 from "./programAddPage.vue?vue&type=style&index=0&id=ceb492ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb492ee",
  null
  
)

export default component.exports